// extracted by mini-css-extract-plugin
export var locationCard = "_r1-0";